import React from 'react'
import Hero from '../Components/Hero'
import Counters from '../Components/Counters'
import WhatWeOffer from '../Components/WhatWeOffer'
import WhyTelegram from '../Components/WhyTelegram'
import AdsFormat from '../Components/AdsFormat'
import Analityka from '../Components/Analityka'
import ForWho from '../Components/ForWho'
import StartNow from '../Components/StartNow'

const Home = () => {
  return (
    <div>
        <Hero />
        <Counters />
        <WhatWeOffer/>
        <WhyTelegram />
        <AdsFormat />
        <Analityka />
        <ForWho />
        <StartNow />

    </div>
  )
}

export default Home